import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    Box,
    Divider,
    Stack,
    Typography,
    useTheme,
    Select,
    MenuItem,
    IconButton,
    Button,
} from "@mui/material";
import { ArrowsCounterClockwise, Circle, Desktop, PlayCircle, SignOut, WifiLow, WifiSlash } from "phosphor-react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { Offline, Online } from "react-detect-offline";

const TopBar = () => {
    const theme = useTheme();
    const [status, setStatus] = useState("Available");
    const [open, setOpen] = useState(false);
    const username = localStorage.getItem("username");
    const navigate = useNavigate(); // Initialize navigate

    const handleChange = (event) => {
        setStatus(event.target.value);
    };

    const handleRefresh = () => {
        window.location.reload(); // Reloads the current page
    };

    const handleLogout = async () => {
        const userId = localStorage.getItem("userId");
        const deviceId = localStorage.getItem("deviceId");
        const company = localStorage.getItem("company");
        const username = localStorage.getItem("username");
        const email = localStorage.getItem("email");
        const role = localStorage.getItem("role");

        if (!userId || !deviceId) {
            console.error("User ID or Device ID not found in localStorage");
            return;
        }

        try {
            // Send request to backend to update logout time and is_active
            await fetch(`${process.env.REACT_APP_API_URL}/api/logout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ userId, deviceId, company, username, email, role }),
            });

            // Remove specific keys from localStorage except 'selectedUser'
            Object.keys(localStorage).forEach((key) => {
                if (key !== "selectedUser") {
                    localStorage.removeItem(key);
                }
            });

            // Show Snackbar notification
            setOpen(true);

            // Redirect to login page after Snackbar auto-closes
            setTimeout(() => {
                navigate("/auth/login");
            }, 2000); // Matches Snackbar autoHideDuration
        }
        catch (error) {
            console.error("Logout error:", error);
        }
    };

    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
    };

    return (
        <Box sx={{ backgroundColor: theme.palette.primary.main, height: "100%", width: "100%" }}>
            <Stack direction="row" alignItems="center" px={1} height="100%" justifyContent="space-between">
                <Stack spacing={1.5} direction="row" alignItems="center">
                    <Typography
                        color="#fff"
                        variant="body" // You can adjust this based on your theme variants
                        style={{
                            // fontWeight: "bold",
                            letterSpacing: "1px",
                            // textTransform: "uppercase", 
                            // fontSize: "16px",
                        }}
                    >
                        TeamChatX
                    </Typography>

                    <Divider orientation="vertical" variant="middle" flexItem />
                    <Typography color={"#fff"} variant="body">
                        {username}
                    </Typography>
                    {/* Status Dropdown */}
                    <Select
                        value={status}
                        onChange={handleChange}
                        displayEmpty
                        size="small"
                        variant="outlined"
                        sx={{
                            ".MuiSelect-select": {
                                minHeight: "8px !important",
                                height: "8px !important",
                                display: "flex",
                                alignItems: "center",
                            },
                            Width: 150,
                            background: "#eee",
                            color: "#000",
                        }}
                        renderValue={(value) => (
                            <Stack direction="row" spacing={1} alignItems="center">
                                {value === "Available" && <Circle color="green" sx={{ marginRight: 1 }} weight="fill" />}
                                {value === "DND" && <Circle color="red" sx={{ marginRight: 1 }} weight="fill" />}
                                <Typography variant="body2">{value || "Select Status"}</Typography>
                            </Stack>
                        )}
                    >
                        <MenuItem value="Available">
                            <Circle color="green" sx={{ marginRight: 2 }} weight="fill" /> Available
                        </MenuItem>
                        <MenuItem value="DND">
                            <Circle color="red" sx={{ marginRight: 2 }} weight="fill" /> DND
                        </MenuItem>
                    </Select>

                    {/* Refresh Icon */}
                    <IconButton onClick={handleRefresh} sx={{ marginLeft: 2 }} title="refresh">
                        <ArrowsCounterClockwise size={25} color="#ddd" />
                    </IconButton>

                    {/* Internet Status */}

                    <Offline>
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{
                                backgroundColor: "#1a1a1a",
                                borderRadius: "16px",
                                padding: "4px 12px",
                                boxShadow: "0px 2px 6px rgba(182, 43, 43, 0.2)",
                                
                            }}
                        >
                            <Typography color="white" variant="caption">
                                No Internet
                            </Typography>
                            <WifiSlash style={{ color: "red" }} size={20} />
                        </Stack>
                    </Offline>

                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                    {/* Desktop App Button */}
                    <Button
                        variant="body2"
                        startIcon={<Desktop />}
                        sx={{
                            fontSize: "10px",
                            color: "#fff",
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(10px)",
                            borderRadius: "5px",
                            "&:hover": {
                                borderColor: "rgba(255, 255, 255, 1)",
                            },
                            padding: "2px 8px",
                            margin: "4px",
                        }}
                    >
                        Desktop App
                    </Button>

                    {/* Quick Tour Button */}
                    <Button
                        variant="body2"
                        startIcon={<PlayCircle />}
                        sx={{
                            fontSize: "10px",
                            color: "#fff",
                            border: "1px solid rgba(255, 255, 255, 0.6)",
                            backdropFilter: "blur(10px)",
                            borderRadius: "5px",
                            "&:hover": {
                                borderColor: "rgba(255, 255, 255, 1)",
                            },
                            padding: "2px 8px",
                            margin: "4px",
                        }}
                    >
                        Quick Tour
                    </Button>
                    <Divider orientation="vertical" variant="middle" flexItem />
                    {/* Logout Button */}
                    <Button
                        variant="body2"
                        endIcon={<SignOut />}
                        sx={{
                            fontSize: "13px",
                            color: "#fff",
                            height: "auto",
                            backgroundColor:"#000",
                            borderRadius: "5px",
                            
                            padding: "2px 16px",
                            margin: "4px",
                        }}
                        onClick={handleLogout}
                    >
                        Logout
                    </Button>
                    <Snackbar
                        open={open}
                        autoHideDuration={2000}
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                        <Alert onClose={handleClose} severity="success">
                            Successfully logged out!
                        </Alert>
                    </Snackbar>
                </Stack>
            </Stack>
        </Box>
    );
};

export default TopBar;
